import React from 'react'
import { Layout } from 'antd'
import sandWatch from '../../images/sandWatch.png'

import PageHeader from '@/components/PageHeader'
export default function Setting() {
  return (
    <Layout className="Attendance-V3">
      <PageHeader ghost={false} title="考勤设置" />
      <div className="main">
        <div className="flex-center">
          <div className="img">
            <img src={sandWatch} />
          </div>
          <div className="desc">
            电脑端考勤即将上线
            <br />
            请在手机端设置
          </div>
        </div>
      </div>
    </Layout>
  )
}
